import { create } from 'zustand'
import { persist, devtools } from 'zustand/middleware'
import { useLabVariantStore } from '../modules/PatientPortal/components/LabResults/useLabVariant'

interface AuthState {
  token: string | null
  tokenType: string | null
  refreshToken: string | null // Add the refresh token
  email: string | null
  setToken: (token: string, tokenType: string) => void
  setRefreshToken: (refreshToken: string) => void // Method to update the refresh token
  setEmail: (email: string) => void
  clearToken: () => void
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        token: null,
        tokenType: null,
        refreshToken: null,
        email: null,
        setToken: (token: string = '', tokenType: string = '') => {
          set({ token, tokenType }, false, 'setToken')
        },
        setRefreshToken: (refreshToken: string) => {
          set({ refreshToken }, false, 'setRefreshToken')
        },
        setEmail: (email: string) => {
          set({ email }, false, 'setEmail')
        },
        clearToken: () => {
          set({ token: null, tokenType: null, refreshToken: null }, false, 'clearToken')
          useLabVariantStore.setState({ variantKeys: {} })
        },
      }),
      {
        name: 'auth-storage',
      },
    ),
    { name: 'AuthStore' },
  ),
)
